const params = [
  { programs: "Game Development", value: "GAME" },
  { programs: "Interactive Design", value: "INTR" },
  { programs: "Visual Communication", value: "SCOM" },
];

export default params;
